var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoctorIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.666 2.66602V5.33268",
    stroke: "#009A9A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 2.66602V5.33268",
    stroke: "#009A9A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 4H5.33268C4.62544 4 3.94716 4.28095 3.44706 4.78105C2.94697 5.28115 2.66602 5.95942 2.66602 6.66667V12C2.66602 14.1217 3.50887 16.1566 5.00916 17.6569C6.50945 19.1571 8.54428 20 10.666 20C12.7877 20 14.8226 19.1571 16.3229 17.6569C17.8232 16.1566 18.666 14.1217 18.666 12V6.66667C18.666 5.95942 18.3851 5.28115 17.885 4.78105C17.3849 4.28095 16.7066 4 15.9993 4H14.666",
    stroke: "#009A9A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 20C10.666 22.1217 11.5089 24.1566 13.0092 25.6569C14.5095 27.1571 16.5443 28 18.666 28C20.7877 28 22.8226 27.1571 24.3229 25.6569C25.8232 24.1566 26.666 22.1217 26.666 20V16",
    stroke: "#009A9A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 15.9993C28.1394 15.9993 29.3333 14.8054 29.3333 13.3327C29.3333 11.8599 28.1394 10.666 26.6667 10.666C25.1939 10.666 24 11.8599 24 13.3327C24 14.8054 25.1939 15.9993 26.6667 15.9993Z",
    stroke: "#009A9A",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorIconBlue);
export default __webpack_public_path__ + "static/media/doctor-iconBlue.bc669a157ab6d10c94b185e521bb0ae2.svg";
export { ForwardRef as ReactComponent };